/**
 * Prepends Vite's BASE_URL to static asset paths.
 * This ensures assets resolve correctly when the app is served at a sub-path (e.g., /app/).
 *
 * @param path - The asset path (e.g., '/logo/logo.svg' or 'logo/logo.svg')
 * @returns The full path with the base URL prepended
 */
export function assetPath(path: string): string {
    const base = import.meta.env.BASE_URL
    const cleanPath = path.startsWith('/') ? path.slice(1) : path
    return `${base}${cleanPath}`
}

